module.exports = __webpack_public_path__ + "img/list-number.d298f75e.svg";